import React from "react";

export interface FilterTagGroupDisplay {
    title: string;
    tags: string[];
}

interface FilterTagGroupsProps {
    groups: FilterTagGroupDisplay[];
    emptyLabel: string;
}

const FilterTagGroups: React.FC<FilterTagGroupsProps> = ({groups, emptyLabel}) => {
    if (!groups.length) {
        return <span className="text-sm text-gray-500">{emptyLabel}</span>;
    }

    return (
        <div className="flex flex-col gap-3">
            {groups.map((group) => (
                <div key={group.title}>
                    <div className="text-xs font-semibold uppercase text-gray-500 mb-1">{group.title}</div>
                    <div className="flex flex-wrap gap-2">
                        {group.tags.map((tag, index) => (
                            <span
                                key={`${group.title}-${tag}-${index}`}
                                className="rounded-full border border-blue-gray-100 bg-blue-gray-50 px-2 py-0.5 text-xs text-gray-900 dark:border-blue-gray-700 dark:bg-blue-gray-800 dark:text-gray-100"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FilterTagGroups;
